export default "__VITE_ASSET__BQfH5XP9__"